import { HttpAction } from "@megaron/http-service";
import { Serializers, SerializerValue } from "@megaron/serializers";
import { uuidSerializer } from "@megaron/uuid";

export const mentionSerializer = Serializers.object({
  user: Serializers.string,
  tagPosition: Serializers.integer,
  tagLength: Serializers.integer,
});

export type Mention = SerializerValue<typeof mentionSerializer>;

export const commentResourceTypes = ["supportTicket", "crmCustomer"] as const;
export type CommentResourceType = (typeof commentResourceTypes)[number];

export const commentAttachmentSummarySerializer = Serializers.object({
  id: uuidSerializer,
  fileName: Serializers.string,
  fileType: Serializers.string,
});

export type CommentAttachmentSummaryDto = SerializerValue<typeof commentAttachmentSummarySerializer>;

export const commentAttachmentPayloadSerializer = Serializers.object({
  fileName: Serializers.string,
  fileType: Serializers.string,
  contentBase64: Serializers.string,
});

export type CommentAttachmentPayloadDto = SerializerValue<typeof commentAttachmentPayloadSerializer>;

export const commentSerializer = Serializers.object({
  id: uuidSerializer,
  resourceType: Serializers.stringOneOf(...commentResourceTypes),
  resourceId: Serializers.string,
  body: Serializers.string,
  authorEmail: Serializers.string.optional(),
  mentions: mentionSerializer.array(),
  attachments: commentAttachmentSummarySerializer.array(),
  createdAt: Serializers.datetime,
});

export type CommentDto = SerializerValue<typeof commentSerializer>;

export const commentsActions = {
  commentsByResource: HttpAction({
    path: "/comments",
    method: "get",
    qsSerializer: Serializers.object({
      resourceType: Serializers.stringOneOf(...commentResourceTypes),
      resourceId: Serializers.string,
    }),
    valueSerializer: commentSerializer.array(),
    requiresAuth: true,
  }),

  createComment: HttpAction({
    path: "/comments",
    method: "post",
    bodySerializer: Serializers.object({
      resourceType: Serializers.stringOneOf(...commentResourceTypes),
      resourceId: Serializers.string,
      body: Serializers.string,
      mentions: mentionSerializer.array().optional(),
      attachments: commentAttachmentPayloadSerializer.array().optional(),
    }),
    valueSerializer: commentSerializer,
    requiresAuth: true,
  }),

  getCommentAttachment: HttpAction({
    path: "/comments/:commentId/attachments/:attachmentId",
    method: "get",
    paramsSerializer: Serializers.object({
      commentId: uuidSerializer,
      attachmentId: uuidSerializer,
    }),
    valueSerializer: commentAttachmentPayloadSerializer,
    errorSerializer: Serializers.stringOneOf("CommentNotFound", "AttachmentNotFound"),
    requiresAuth: true,
  }),
};
